export enum CashRegisterVendorTypeEnum {
  MANUEL = "MANUEL",
  ODEAL = "ODEAL",
  OMNISOFT = "OMNISOFT",
  SMARTONE = "SMARTONE",
  NBASOFT = "NBASOFT",
  HUGIN = "HUGIN",
  INPOS = "INPOS",
  PAVO = "PAVO",
  BEKO = "BEKO",
  CASPOS = "CASPOS"
}

export const CashRegisterVendorTypeEnumValues: string[] = [
  CashRegisterVendorTypeEnum.MANUEL,
  CashRegisterVendorTypeEnum.ODEAL,
  CashRegisterVendorTypeEnum.OMNISOFT,
  CashRegisterVendorTypeEnum.SMARTONE,
  // CashRegisterVendorTypeEnum.NBASOFT,
  CashRegisterVendorTypeEnum.HUGIN,
  CashRegisterVendorTypeEnum.INPOS,
  CashRegisterVendorTypeEnum.PAVO,
  CashRegisterVendorTypeEnum.BEKO,
  CashRegisterVendorTypeEnum.CASPOS
];

export const CashRegisterVendorTypeEnumLocalValues: string[] = [
  CashRegisterVendorTypeEnum.OMNISOFT,
  CashRegisterVendorTypeEnum.SMARTONE,
  // CashRegisterVendorTypeEnum.NBASOFT,
  CashRegisterVendorTypeEnum.PAVO,
  CashRegisterVendorTypeEnum.CASPOS
];
export const CashRegisterVendorTypeEnumForWaitResponseValues: string[] = [
  CashRegisterVendorTypeEnum.ODEAL,
  CashRegisterVendorTypeEnum.HUGIN,
  CashRegisterVendorTypeEnum.INPOS,
  CashRegisterVendorTypeEnum.BEKO,
];

export interface CashRegisterVendorCapabilities {
  pairDevice?: boolean;
  openShift?: boolean;
  closeShift?: boolean;
  getXReport?: boolean;
  getZReport?: boolean;
  controlTape?: boolean;
}

export const CashRegisterVendorCapabilitiesMap: Record<string, CashRegisterVendorCapabilities> = {
  [CashRegisterVendorTypeEnum.MANUEL]: {},
  [CashRegisterVendorTypeEnum.ODEAL]: {},
  [CashRegisterVendorTypeEnum.OMNISOFT]: {
    openShift: true,
    closeShift: true,
    getXReport: true,
    getZReport: true,
    controlTape: true
  },
  [CashRegisterVendorTypeEnum.SMARTONE]: {
    openShift: true,
    closeShift: true,
    getXReport: true,
    getZReport: true,
    controlTape: true
  },
  [CashRegisterVendorTypeEnum.NBASOFT]: {
    openShift: true,
    closeShift: true,
    getXReport: true,
    getZReport: true,
    controlTape: true
  },
  [CashRegisterVendorTypeEnum.HUGIN]: {},
  [CashRegisterVendorTypeEnum.INPOS]: {},
  [CashRegisterVendorTypeEnum.PAVO]: {
    pairDevice: true,
    openShift: true,
    closeShift: true,
    getXReport: true,
    getZReport: true,
    controlTape: false
  },
  [CashRegisterVendorTypeEnum.BEKO]: {},
  [CashRegisterVendorTypeEnum.CASPOS]: {
    openShift: true,
    closeShift: true,
    getXReport: true,
    getZReport: true,
    controlTape: true
  }
};

export function hasCashRegisterCapability(vendorType: string | undefined, capability: keyof CashRegisterVendorCapabilities): boolean {
  if (!vendorType) return false;
  return CashRegisterVendorCapabilitiesMap[vendorType]?.[capability] === true;
} 